import { defineMessages } from 'react-intl';

export const metadatas = {
  default: defineMessages({
    title: {
      defaultMessage: 'Real Fantasy Football – Sorare Football',
    },
    description: {
      defaultMessage:
        "Collect, play and win officially licensed digital cards featuring the world's best football players.",
    },
  }),
  market: defineMessages({
    title: {
      defaultMessage: 'Cards Market – Sorare Football',
    },
    description: {
      defaultMessage:
        "Discover new Sorare Football cards featuring the world's best global football players available from top leagues such as Premier League, LaLiga, SerieA, Bundesliga and Ligue 1",
    },
  }),
  newSignings: defineMessages({
    title: {
      defaultMessage: 'New Cards Auctions – Sorare Football',
    },
    description: {
      defaultMessage:
        "Find and collect Sorare Football cards featuring the world's best global football players available from top leagues such as Premier League, LaLiga, SerieA, Bundesliga and Ligue 1",
    },
  }),
  transfers: defineMessages({
    title: {
      defaultMessage: 'Manager Sales Market – Sorare Football',
    },
    description: {
      defaultMessage:
        'Find, collect and trade cards with other Sorare Managers',
    },
  }),
  playerOverview: defineMessages({
    title: {
      defaultMessage: '{player} – Player Profile',
    },
    description: {
      defaultMessage:
        'Find all statistics of {player}: ratings, goals, assists, rankings and more. Collect and trade officially licensed digital cards of your favorite players.',
    },
  }),
  nationalTeamOverview: defineMessages({
    title: {
      defaultMessage: '{country} National Football Team – Team Profile',
    },
    description: {
      defaultMessage:
        'Overview of games, players and statistics of {country} National Football Team. Collect and trade digital cards of your favorite players.',
    },
  }),
  clubOverview: defineMessages({
    title: {
      defaultMessage: '{club} – Club Profile',
    },
    description: {
      defaultMessage:
        'Overview of standings, fixtures, transfers, squad and statistics of {club}. Collect and trade officially licensed digital cards of your favorite players.',
    },
  }),
  clubStandings: defineMessages({
    title: {
      defaultMessage: '{club} Standings',
    },
    description: {
      defaultMessage:
        'History and current {club} standings. Collect and trade officially licensed digital cards of your favourite players on Sorare.',
    },
  }),
  clubFixtures: defineMessages({
    title: {
      defaultMessage: '{club} Fixtures',
    },
    description: {
      defaultMessage:
        'All {club} fixtures, scores, results and upcoming games. Collect and trade officially licensed digital cards of your favourite players on Sorare.',
    },
  }),
  clubSquad: defineMessages({
    title: {
      defaultMessage: '{club} Players',
    },
    description: {
      defaultMessage:
        '{club} players: forward, defender, midfielder, goalkeeper and manager. Collect and trade officially licensed digital cards on Sorare.',
    },
  }),
  clubCards: defineMessages({
    title: {
      defaultMessage: '{club} Cards – Collect and Trade',
    },
    description: {
      defaultMessage:
        'Find all the officially licensed digital cards of {club}: Limited, Rare, Super Rare, Unique. Only on Sorare.',
    },
  }),
  leagueOverview: defineMessages({
    title: {
      defaultMessage: '{league} – League Profile',
    },
    description: {
      defaultMessage:
        'Overview of fixtures, tables, squads and statistics of the {league}. Collect and trade officially licensed digital cards of your favorite players.',
    },
  }),
  leagueFixtures: defineMessages({
    title: {
      defaultMessage: '{league} Fixtures',
    },
    description: {
      defaultMessage:
        'All {league} fixtures, scores, results and upcoming games. Collect and trade officially licensed digital cards of your favorite players.',
    },
  }),
  leagueCards: defineMessages({
    title: {
      defaultMessage: '{league} Cards – Collect and Trade',
    },
    description: {
      defaultMessage:
        'Find all the officially licensed digital cards of {league}: Limited, Rare, Super Rare, Unique. Only on Sorare.',
    },
  }),
  country: defineMessages({
    title: {
      defaultMessage: '{country} – Top Players – Sorare Football',
    },
    description: {
      defaultMessage:
        'Collect, trade and play with Sorare cards of players from {country} in different scarcities and own your game',
    },
  }),
  instantBuy: defineMessages({
    title: {
      defaultMessage: 'Instant Buy Market – Sorare Football',
    },
    description: {
      defaultMessage:
        "Find and collect Sorare cards featuring the world's best global football players available from top leagues such as Premier League, LaLiga, SerieA, Bundesliga and Ligue 1",
    },
  }),
  composeTeam: defineMessages({
    title: {
      defaultMessage: '{leaderboardName} – Sorare Football',
    },
  }),
};
